export type ReadStopwatch = () => number;

/**
 * Create a stopwatch function that returns the time elapsed since the stopwatch was created.
 * @returns A function that returns the time elapsed since the stopwatch was created.
 * @example
 * const stopwatch = startStopwatch();
 * // ... do something ...
 * const elapsed = stopwatch();
 */
export function startStopwatch(): ReadStopwatch {
    const start = time();
    return () => {
        const end = time();
        return end - start;
    };
}

/**
 * Returns the current time in milliseconds. It uses the most accurate timer available in the environment.
 */
export function time(): number {
    if (typeof performance !== 'undefined' && performance.now) {
        return performance.now();
    }

    return Date.now();
}

/**
 * Returns the current wall-clock time in epoch milliseconds.
 */
export function epochTime(): number {
    if (
        typeof performance !== 'undefined' &&
        performance.now &&
        Number.isFinite(performance.timeOrigin)
    ) {
        return performance.timeOrigin + performance.now();
    }

    return Date.now();
}
